module.exports = __webpack_public_path__ + "img/stzl.14e0ffce.png";